export function getFlatValidationErrors(errors, showLastConstraint = true, constraintSeparator = '\n') {
    const flatErrors = [];
    function toFlatError(error, parentPath) {
        const formattedProperty = Number.isInteger(+error.property) ? `[${error.property}]` : `${parentPath ? '.' : ''}${error.property}`;
        if (error.constraints && Object.entries(error.constraints).length) {
            const message = showLastConstraint
                ?
                    `${Object.values(error.constraints).pop()}`
                : Object.values(error.constraints).join(constraintSeparator);
            flatErrors.push({
                path: `${parentPath}${formattedProperty}`,
                message,
            });
        }
        else if (Array.isArray(error.children) && error.children.length > 0) {
            for (const child of error.children) {
                toFlatError(child, `${parentPath}${formattedProperty}`);
            }
        }
    }
    for (const error of errors) {
        toFlatError(error, '');
    }
    return flatErrors;
}
//# sourceMappingURL=flat-validation-error.js.map